module.exports = __webpack_public_path__ + "static/media/bg-timeline.4ca367b2.jpg";